import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { version } from '../../package.json';
import { forkJoin, Observable, of } from 'rxjs';
import { ThemeService } from './core/services/theme.service';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { merge } from 'lodash-es';

export function TranslateHttpLoaderFactory(http: HttpClient, themeService: ThemeService) {
  return {
    getTranslation(lang: string): Observable<Object> {
      return forkJoin([
        new TranslateHttpLoader(http, 'assets/i18n/', `.json?${btoa(version)}`).getTranslation(
          lang
        ),
        getThemeOverride(themeService, lang),
      ]).pipe(
        map(([base, override]) => {
          return merge(base, override);
        })
      );
    },
  };
}

function getThemeOverride(themeService: ThemeService, lang: string): Observable<Object> {
  const translates = themeService.themeSig()?.translates;
  if (translates && translates[lang]) {
    return of(translates[lang]);
  }
  return of({});
}
